export default __webpack_public_path__ + "static/media/logo.5032a41b.svg";